import { render, staticRenderFns } from "./_Competition.vue?vue&type=template&id=cce861d4&"
import script from "./_Competition.vue?vue&type=script&lang=js&"
export * from "./_Competition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports